import React, { Fragment, useEffect } from "react"
import { Form, Input, Button, Col } from "antd"

import { useLocation } from "react-router-dom"
import { useNavigate } from "react-router"
import { connect } from "react-redux"

import { InitializeTicket, InitializeTicketDetails } from "../../../redux/action"
import Navbar from "../../../atoms/navbar"
import Footer from "../../../atoms/footer"
import { sanitizePhoneNumber } from "../../../lib/utils"

import "antd/dist/antd.css"

function CreateTicket(props) {
  const [form] = Form.useForm()
  const hasAutoSubmitted = React.useRef(false)
  const location = useLocation()
  const base = location.pathname.startsWith("/saphelp") ? "/saphelp" : "/help"
  const navigate = useNavigate()

  /* eslint-disable-next-line no-unused-vars */
  const isAuthenticated = false

  const onFinish = values => {
    const getNumber = values.phonenumber.split("")
    if (getNumber[0] === "0") {
      getNumber[0] = "62"
      values.phonenumber = getNumber.join("")
    }

    props.setInitializeTicket(navigate, values, base)
  }

  const loadProfile = React.useCallback(() => {
    let email = props.initializeTicket?.email
    let fullname = props.initializeTicket?.fullname
    let phonenumber = sanitizePhoneNumber(props.initializeTicket?.phone_number || props.initializeTicket?.phonenumber)
    let shouldAutoSubmit = false

    if (!email || !fullname || !phonenumber) {
      try {
        const sessionData = localStorage.getItem("session_signin")
        if (sessionData) {
          const parsedSession = JSON.parse(sessionData)
          const sessionEmail = parsedSession?.email
          const sessionFullname = parsedSession?.fullname
          const sessionPhonenumber = sanitizePhoneNumber(parsedSession?.phone_number || parsedSession?.phonenumber)

          shouldAutoSubmit = Boolean(sessionEmail && sessionFullname && sessionPhonenumber)

          if (!email) email = sessionEmail
          if (!fullname) fullname = sessionFullname
          if (!phonenumber) phonenumber = sessionPhonenumber
        }
      } catch (e) {
        console.warn("Error parsing session_signin", e)
      }
    }

    form.setFieldsValue({
      email: email,
      fullname: fullname,
      phonenumber: phonenumber,
    })

    if (shouldAutoSubmit && !hasAutoSubmitted.current) {
      hasAutoSubmitted.current = true
      form.submit()
    }
  }, [props.initializeTicket, form])

  useEffect(() => {
    loadProfile()
  }, [loadProfile, props.initializeTicket])

  return (
    <Fragment>
      <Navbar title="New Ticket" subtitle={base} back={true} navigate={`${base}/history-ticket`} />
      <div className="container white-back-cr">
        <div className="container my-3 p-4">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <p className="fs-6 fw-bold">Contact Information</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Form
                form={form}
                name="contact_information"
                labelCol={{
                  span: 5,
                }}
                wrapperCol={{
                  span: 12,
                }}
                initialValues={{
                  remember: true,
                }}
                onFinish={onFinish}
                autoComplete={false}
                size="large"
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email !",
                      type: "email",
                    },
                  ]}
                >
                  <Input placeholder="Enter your email" />
                </Form.Item>

                <Form.Item
                  label="Full Name"
                  name="fullname"
                  autocomplete={false}
                  rules={[
                    {
                      required: true,
                      message: "Please input your name !",
                    },
                  ]}
                >
                  <Input placeholder="Enter your name" />
                </Form.Item>

                <Form.Item
                  label="Phone Number"
                  name="phonenumber"
                  autocomplete={false}
                  className="w-full"
                  rules={[
                    {
                      required: true,
                      message: "Please input your phone number !",
                    },
                    {
                      pattern: /^[0-9]+$/,
                      message: "Phone number must be only numbers!",
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter your phone number"
                    onKeyPress={event => {
                      if (!/[0-9]/.test(event.key)) {
                        event.preventDefault()
                      }
                    }}
                  />
                </Form.Item>

                <Col xs={{ span: 12 }} lg={{ span: 12, offset: 5 }}>
                  <Form.Item>
                    <Button type="primary" htmlType="submit">
                      Next
                    </Button>
                  </Form.Item>
                </Col>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Fragment>
  )
}

const reduxState = state => ({
  initializeTicket: state.initializeTicket,
})

const reduxDispatch = dispatch => ({
  setInitializeTicket: (navigate, data, base) => dispatch(InitializeTicket(navigate, data, base)),
  setInitializeTicketDetails: data => dispatch(InitializeTicketDetails(null, data)),
})

export default connect(reduxState, reduxDispatch)(CreateTicket)
